module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_VIANDE_LISTE_NOM.c8d62dcd.svg";